import {getPaymentEvent, listPaymentEvents} from './queries';

import {GraphQLQuery} from '@aws-amplify/api';
import {GetPaymentEvent, ListPaymentEvents, PaymentEventStatus} from '../types';
import {billingApiClient} from '../../billing-api-integration';
import {ListRecordsQuery} from '../../../types';

const client = billingApiClient;

export type PaymentEventsFilter = {
    invoiceId?: string,
    customerId?: string,
    status?: PaymentEventStatus,
};

export const fetchRecords = async (
    query: ListRecordsQuery & { filter?: PaymentEventsFilter },
) => {
    const response = await client.graphql<GraphQLQuery<ListPaymentEvents>>({
        query: listPaymentEvents,
        variables: {
            ...query,
        },
    });
    return {
        items: response.data?.listPaymentEvents.items,
        nextToken: response.data?.listPaymentEvents.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPaymentEvent>>({
        query: getPaymentEvent,
        variables: {id},
    });
    return response.data?.getPaymentEvent;
};
